// GAVION A12: reads the held / needs-review sends for admins (see emailAttention.ts). Same resources in
// Supabase (admin RLS) and FakeRest (demo collections). Errors degrade to an empty list, no toast.
import { useGetList } from "ra-core";
import { useMemo } from "react";
import { collectAttention, type AttentionItem } from "./emailAttention";

const PAGE = { page: 1, perPage: 500 };
const SORT = { field: "id", order: "DESC" as const };
const OPTS = { retry: false, staleTime: 60_000 };

const useRows = (resource: string, filter: Record<string, unknown> = {}) =>
  useGetList(resource, { pagination: PAGE, sort: SORT, filter }, OPTS);

export const useEmailAttention = (): {
  items: AttentionItem[];
  held: number;
  review: number;
  isPending: boolean;
  error: unknown;
} => {
  const enrollments = useRows("sequence_enrollments", {
    status: "active",
    "last_error@not.is": null,
  });
  const actions = useRows("scheduled_actions", { status: "needs_review" });
  const recipients = useRows("campaign_recipients", { status: "failed" });
  const sequences = useRows("sequences");
  const campaigns = useRows("campaigns");
  const items = useMemo(
    () =>
      collectAttention({
        now: new Date(),
        enrollments: enrollments.data,
        actions: actions.data,
        recipients: recipients.data,
        sequences: sequences.data,
        campaigns: campaigns.data,
      }),
    [
      enrollments.data,
      actions.data,
      recipients.data,
      sequences.data,
      campaigns.data,
    ],
  );
  return {
    items,
    held: items.filter((i) => i.kind === "held").length,
    review: items.filter((i) => i.kind === "review").length,
    isPending:
      enrollments.isPending || actions.isPending || recipients.isPending,
    error: enrollments.error || actions.error || recipients.error,
  };
};
